var __jsx = React.createElement;
import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'next-i18next';
import { MediaContext } from '@spa/shared/contexts/media';
import MiniCamera from '@spa/shared/svg/mini-camera';
import { modalIds } from '@spa/offer/components/Modals/modal-displayer';
import { showModalAction } from '@spa/shared/store/actions/modal';
import { PHOTO_SIZES } from '@spa/shared/constants/photos';
import { findPhotoById, photoUrl } from '@spa/shared/utils/photos';
import GalleryButtons from './GalleryButtons';
import { Photo, PhotosChip, Wrapper, MainPhoto, Fomo } from './styles';
import { trackGalleryOpened } from '@spa/offer/store/actions/tracking';
import { PHOTOS_MODAL_SECTIONS } from '@spa/offer/constants/modals';
import Placeholder from '@spa/shared/components/Unisystem/Placeholder';
var SHOW_FOMO_THRESHOLD = 10;
var Gallery = function Gallery(_ref) {
  var mainPhoto = _ref.mainPhoto,
    thumbnails = _ref.thumbnails,
    totalPhotos = _ref.totalPhotos,
    offerViews = _ref.offerViews,
    showGallery = _ref.showGallery;
  var _useContext = useContext(MediaContext),
    is = _useContext.is;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return __jsx(React.Fragment, null, __jsx(Wrapper, {
    isMobile: is.mobile
  }, offerViews >= SHOW_FOMO_THRESHOLD && __jsx(Fomo, null, __jsx("span", null, "".concat(offerViews, " ").concat(t('views'))), t('in the last 12h')), __jsx(MainPhoto, {
    src: photoUrl({
      hash: mainPhoto === null || mainPhoto === void 0 ? void 0 : mainPhoto.hash,
      size: PHOTO_SIZES.X_LARGE
    }),
    isMobile: is.mobile,
    onClick: showGallery
  }), is.notMobile && thumbnails.slice(0, 4).map(function (_ref2, index) {
    var hash = _ref2.hash,
      unitType = _ref2.unitType,
      isPlaceholder = _ref2.isPlaceholder;
    return hash && !isPlaceholder ? __jsx(Photo, {
      key: "".concat(hash, "-").concat(index),
      src: photoUrl({
        hash: hash,
        size: PHOTO_SIZES.MEDIUM
      }),
      onClick: showGallery
    }) : __jsx(Placeholder, {
      key: "placeholder-".concat(index),
      type: unitType,
      title: t('No photo yet')
      // eslint-disable-next-line prettier/prettier
      ,
      subtitle: t('but we\'re working on it!'),
      onClick: showGallery
    });
  }), __jsx(PhotosChip, {
    isPrimary: true,
    isGalleryHover: is.mobile,
    label: is.mobile ? totalPhotos : t('Photos'),
    icon: MiniCamera,
    onClick: showGallery
  })), __jsx(GalleryButtons, null));
};
var mapStateToProps = function mapStateToProps(_ref3) {
  var _ref3$offer = _ref3.offer,
    mainPhotoId = _ref3$offer.offerAggregate.accommodation_offer.main_photo.id,
    photosModal = _ref3$offer.photosModal,
    offerViews = _ref3$offer.offerViews;
  var photos = (photosModal === null || photosModal === void 0 ? void 0 : photosModal.photos) || [];
  return {
    mainPhoto: findPhotoById(mainPhotoId, photos),
    thumbnails: photos.filter(function (photo) {
      return photo.id !== mainPhotoId;
    }),
    totalPhotos: photos.length,
    offerViews: offerViews
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showGallery: function showGallery() {
      dispatch(trackGalleryOpened());
      dispatch(showModalAction({
        modalId: modalIds.PHOTOS_MODAL,
        section: PHOTOS_MODAL_SECTIONS.photos.label
      }));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Gallery);